import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { Img, Button, Modal } from "arv-reactcomponents";
import Anchor from "../../Anchor";
import GetRating from "../../../component/PdpComponents/RatingAndReview/GetRating";
import Exchange from "../../Exchange";
import GetRatingAndReview from "../../../component/PdpComponents/RatingAndReview/GetRatingAndReview";
import ViewReviewPage from "../../../component/PdpComponents/RatingAndReview/ViewReviewPage";
import { REVIEW, REVIEWS_DELIVERY_CONFIRMATION } from "npmlinks-constants";
import ReviewUpdatePage from "../../../component/PdpComponents/RatingAndReview/ReviewUpdatePage";
import {
  ORDERDETAILS,
  HIDE_BRANDNAME,
  pageType,
  Endpoints
} from "npmlinks-constants";
import { ToCurrency } from "../../../utils";

const {
  RETURN_ELIGIBLE,
  CANCEL_ELIGIBLE,
  EXCHANGE_ELIGIBLE,
  CARTPRODUCTS
} = ORDERDETAILS;

const isDiscountedItem = (mrp, discountedAmount) => mrp > discountedAmount;

@inject("ProductStore")
@observer
class ConsignmentImage extends Component {
  static historyState(link) {
    return {
      pathname: link,
      state: {
        currentPage: pageType.pdp
      }
    };
  }

  constructor(props) {
    super(props);
    const {
      item: { product }
    } = props;
    const { image = "" } = product;
    this.state = {
      mainImage: image,
      modalOpen: false,
      writeReview: false,
      viewReview: false,
      updateReview: false,
      updateReviewPage: false
    };
    this.returnType = this.returnType.bind(this);
    this.onReturnClick = this.onReturnClick.bind(this);
    this.onMainImageError = this.onMainImageError.bind(this);
    this.onProductClick = this.onProductClick.bind(this);
    this.viewReview = this.viewReview.bind(this);
    this.updateReview = this.updateReview.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    this.reviewButtonComponent;
  }
  returnType(eligibleForReturn, eligibleForCancellation) {
    const returns = (eligibleForReturn && RETURN_ELIGIBLE) || "";
    const cancel = (eligibleForCancellation && CANCEL_ELIGIBLE) || "";
    this.type = returns || cancel || "";
    const returnClass = this.type ? "" : "nwc-hide";
    return {
      returnType: this.type,
      returnClass
    };
  }

  onReturnClick(event, itemId, addressId, returnType) {
    event.preventDefault();
    this.props.returnClick(itemId, addressId, returnType);
  }

  onMainImageError() {
    this.setState({ mainImage: Endpoints.noImg });
  }

  get mainImage() {
    const { mainImage } = this.state;
    return mainImage || Endpoints.noImg;
  }

  onProductClick() {
    const { url: link, product } = this.props.item;
    const { brand, description, styleId, image } = product;
    const obj = {
      mainStyle: {
        link,
        brandName: brand,
        name: description,
        styleId,
        images: [{ medium: image }]
      }
    };
    this.props.ProductStore.setPdpData(obj);
  }

  // eslint-disable-next-line class-methods-use-this
  strikeMrp(mrp, discountedPrice) {
    return (
      <span>
        <s>{ToCurrency(mrp)}</s>
        {"  "}
        {ToCurrency(discountedPrice)}
      </span>
    );
  }

  get isExchangeEligible() {
    const { item } = this.props;
    const { exchangeDetails, eligibleForExchange } = item;
    return (
      process.env.REACT_APP_EXCHANGE === "true" &&
      eligibleForExchange &&
      exchangeDetails &&
      exchangeDetails.sizeDetails &&
      exchangeDetails.sizeDetails.length > 0
    );
  }

  get buttonComponent() {
    const { item, addressId, consignmentId, orderId } = this.props;
    const {
      itemId,
      eligibleForReturn,
      eligibleForCancellation,
      product,
      exchangeDetails
    } = item;
    const { returnType, returnClass } = this.returnType(
      eligibleForReturn,
      eligibleForCancellation
    );
    return (
      <div className="nw-consignment-buttonblock">
        <Button
          className={`nw-consignment-cancel ${returnClass}`}
          onClick={event =>
            this.onReturnClick(event, itemId, addressId, returnType)
          }
        >
          {returnType}
        </Button>
        {this.isExchangeEligible ? (
          <Fragment>
            <div className={`nw-consignment-buttonseparator ${returnClass}`}>
              {" "}
              |{" "}
            </div>
            <Exchange.component
              className={returnClass}
              data={EXCHANGE_ELIGIBLE}
              productData={product}
              consignmentId={consignmentId}
              orderId={orderId}
              sizeData={exchangeDetails}
            />
          </Fragment>
        ) : null}
      </div>
    );
  }
  writeReview = (event) => {
    event.preventDefault();
    this.setState({ writeReview: true, modalOpen: true });
  };
  viewReview(event){
    event.preventDefault();
    this.setState({ viewReview: true, modalOpen: true });
  };
  updateReview(event){
    event.preventDefault();
    this.setState({ viewReview: false,updateReviewPage: true});
  };

  close = (event) => {
    event.preventDefault();
    this.setState({ modalOpen: false,updateReviewPage: false });
  };

  closeModal () {
    this.setState({ modalOpen: false,updateReviewPage: false });
  }

  get reviewButtonComponent() {
    const { writeReview, viewReview, updateReview } = this.state;
    const { item, key, reviewConfig } = this.props;
    const itemStatusName = item.itemStatus.name;
    let reviews =
      item && item.reviews && item.reviews.length ? item.reviews[0] : {};
    if (REVIEWS_DELIVERY_CONFIRMATION.includes(itemStatusName)) {
      if (item && item.hasOwnProperty("reviews") && item.reviews.length) {
        if (
          (item.reviews &&
            item.reviews.length &&
            item.reviews[0].status == "PUBLISHED") ||
          (item.reviews.length && item.reviews[0].status == "REJECTED")
        ) {
          //SET UPDATE
          this.setState({ updateReview: true });
        } else if (reviews && reviews.status == "UNDER_MODERATION") {
          this.setState({ viewReview: true });
        }
      } else {
        this.setState({ writeReview: true });
      }
    }
  }
  render() {
    const { item, key, reviewConfig } = this.props;
    const { writeReview, viewReview, updateReview,updateReviewPage } = this.state;
    const itemStatusName = item.itemStatus.name;
    let reviews =
      item && item.reviews && item.reviews.length ? item.reviews[0] : {};
    let rating = reviews && reviews.rating ? reviews.rating : 0;
    const { product, url, discountedPrice } = item;
    const {
      brand,
      description,
      mrp,
      color,
      size,
      tenantSize,
      tenantSizeLabel
    } = product;
    const dynamicSizeHeaderValue =
      tenantSize && tenantSizeLabel ? tenantSizeLabel : CARTPRODUCTS.SIZE_TEXT;
    const dynamicSizeValue = tenantSize ? tenantSize : size;

    return (
      <>
      <Anchor.component
        className="nw-consignment-carousel-item"
        onClick={this.onProductClick}
        key={key}
      >
      <a
        href={url}
        to={ConsignmentImage.historyState(url)}
        onClick={this.onProductClick}
      >
        <Img
          className="nw-consignment-image"
          src={this.mainImage}
          onError={this.onMainImageError}
        />
        </a>
        <div className="nw-consignment-product-description">
          {reviewConfig && reviewConfig.isEnabled && REVIEWS_DELIVERY_CONFIRMATION.includes(itemStatusName) && writeReview && (
            <div onClick={event => 
                this.writeReview(event)}> 
            <GetRating.component
              isShowRating={true}
              rating={rating}
              starSize="24px"
            />
            </div>
          )}
          {reviewConfig && reviewConfig.isEnabled && REVIEWS_DELIVERY_CONFIRMATION.includes(itemStatusName) && (viewReview || updateReview) && (
            <div onClick={event => this.viewReview(event)}>
            <GetRating.component
              isShowRating={true}
              rating={rating}
              starSize="24px"
            />
            </div>
          )}
          {!HIDE_BRANDNAME && (
            <div className="nw-consignment-brandtxt">{brand}</div>
          )}
          <div className="nw-consignment-name">{description}</div>
          <div className="nw-consignment-price">
            {isDiscountedItem(mrp, discountedPrice)
              ? this.strikeMrp(mrp, discountedPrice)
              : ToCurrency(mrp)}
          </div>
          <div className="nw-consignment-skudata-descriptiondata">
            {CARTPRODUCTS.COLOR_TEXT}: {color}
          </div>
          <div className="nw-consignment-skudata-descriptiondata">
            {dynamicSizeHeaderValue}: {dynamicSizeValue}
          </div>
          {tenantSize && (
            <div className="nw-consignment-skudata-descriptiondata">
              {" "}
              {CARTPRODUCTS.BRAND_SIZE}: {size}
            </div>
          )}
          {this.buttonComponent}
          {reviewConfig && reviewConfig.isEnabled && writeReview && (
            <Button
              className={"nw-review-viewreviewbutton"}
              onClick={event => 
                this.writeReview(event)}
            >
              {REVIEW.WRITE_A_REVIEW}
            </Button>
          )}
          {reviewConfig && reviewConfig.isEnabled && (viewReview || updateReview) && (
            <Button
              className={"nw-review-viewreviewbutton"}
              onClick={event => this.viewReview(event)}
            >
              {REVIEW.VIEW_REVIEW_BUTTON}
            </Button>
          )}
        </div>
        <Modal
          isOpen={this.state.modalOpen}
          onClose={event => this.close(event)}
          className="nw-customerimage-ordermodal"
        >
          {writeReview && (
            <GetRatingAndReview.component
              itemId={item.itemId}
              productTitle={item.product.brand}
              productDescription={item.product.description}
              image={item.product.image}
              styleId={item.product.styleId}
              itemStatus={item.itemStatus}
              reviewConfig={reviewConfig}
              close={this.closeModal}
            />
          )}
          {viewReview && (
            <ViewReviewPage.component
              itemId={item.itemId}
              productTitle={item.product.brand}
              productDescription={item.product.description}
              image={item.product.image}
              styleId={item.product.styleId}
              itemStatus={item.itemStatus}
              reviewConfig={reviewConfig}
              reviews={reviews}
              color={color}
              size={size}
              updateReview={updateReview}
              updateReviews={this.updateReview}
              reviewStatus={item.reviews && item.reviews[0].status}
            />
          )}
          {updateReviewPage && (
            <ReviewUpdatePage.component
              itemId={item.itemId}
              productTitle={item.product.brand}
              productDescription={item.product.description}
              image={item.product.image}
              styleId={item.product.styleId}
              itemStatus={item.itemStatus}
              reviewConfig={reviewConfig}
              reviews={reviews}
              color={color}
              size={size}
              close={this.closeModal}
            />
          )}
        </Modal>
        </Anchor.component>
        </>
    );
  }
}

ConsignmentImage.defaultProps = {
  item: []
};

ConsignmentImage.wrappedComponent.propTypes = {
  item: PropTypes.arrayOf(PropTypes.object),
  returnClick: PropTypes.func.isRequired,
  addressId: PropTypes.string.isRequired,
  key: PropTypes.number.isRequired,
  ProductStore: PropTypes.shape({
    setPdpData: PropTypes.func.isRequired
  }).isRequired,
  consignmentId: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ConsignmentImage,
  component: ConsignmentImage
};

export default ProjectComponent;
